import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { PromoClicked } from '@app/+landing-cms/actions';

/**
 * When the user clicks on a promotion (Enhanced e-commerce) in the homepage body.
 */
const events = getEvents((action: PromoClicked) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: { ...action.payload }
  }
]);

export default events;
